import { combineReducers } from 'redux';

import { generalRatingReducer } from './generalRating';
import { ecologyRatingReducer } from './ecologyRating';
import { infrastructureRatingReducer } from './infrastructureRating';
import { priceAndQualityBalanceRatingReducer } from './priceAndQualityBalanceRating';
import { transportRatingReducer } from './transportRating';
import { userStatusReducer } from './userStatus';
import { EUserStatus } from '../../types/newReview/userStatus';
import { ENewReviewModalStep, INewReview } from '../../types/newReview';
import { TReduxActions } from '../../types/redux';
import { prosReviewReducer } from './pros';
import { consReviewReducer } from './cons';
import { stepReducer } from './step';
import { openReducer } from './open';
import { reviewAllowedReducer } from './reviewAllowed';
import { nameReviewReducer } from './name';
import { isAnonymousReviewReducer } from './isAnonymous';

interface IDefaultNewReviewProps {
  openByDefault?: boolean;
  reviewAllowed: boolean;
}

export const defaultNewReview = ({ openByDefault, reviewAllowed }: IDefaultNewReviewProps) => ({
  meta: {
    open: !!openByDefault,
    step: ENewReviewModalStep.Rating,
    reviewAllowed,
  },
  data: {
    generalRating: { value: 0 },
    ecologyRating: { value: 0 },
    infrastructureRating: { value: 0 },
    priceAndQualityBalanceRating: { value: 0 },
    transportRating: { value: 0 },
    userStatus: { value: EUserStatus.Seeker },
    pros: { value: null },
    cons: { value: null },
    name: { value: null },
    isAnonymous: { value: null },
  },
});

export const newReviewReducer = combineReducers<INewReview, TReduxActions>({
  meta: combineReducers({
    open: openReducer,
    step: stepReducer,
    reviewAllowed: reviewAllowedReducer,
  }),
  data: combineReducers({
    generalRating: generalRatingReducer,
    ecologyRating: ecologyRatingReducer,
    infrastructureRating: infrastructureRatingReducer,
    priceAndQualityBalanceRating: priceAndQualityBalanceRatingReducer,
    transportRating: transportRatingReducer,
    userStatus: userStatusReducer,
    pros: prosReviewReducer,
    cons: consReviewReducer,
    name: nameReviewReducer,
    isAnonymous: isAnonymousReviewReducer,
  }),
});
